(function(root,factory){
  const api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  else root.WSCheckout=api;
})(typeof globalThis==='object'?globalThis:this,function(){
  'use strict';
  const OWNER='workwear-select-v1';
  const integer=n=>Number.isSafeInteger(n)&&n>0&&n<=10000;
  const safeId=id=>/^\d+$/.test(String(id));
  const identity=item=>JSON.stringify([String(item.variant_id||item.id),Object.entries(item.properties||{}).sort(([a],[b])=>a.localeCompare(b))]);
  function readiness(catalog,country,hasLogo){
    const c=catalog.checkout||{},r=catalog.readiness||{},errors=[];
    for(const flag of ['checkoutDiscounts','checkoutValidation','checkoutPackingRates','paymentsVerified','taxesVerified'])if(r[flag]!==true)errors.push(flag);
    if(catalog.checkoutReady!==true)errors.push('notLaunched');
    if(!c.countries?.includes(country))errors.push('countryNotReady');
    if(hasLogo&&r.artworkUpload!==true)errors.push('artworkUpload');
    return errors;
  }
  function plan(lines,catalog,engine){
    const errors=[],items=[],ids=new Set(),priced=engine.price(lines,catalog);
    errors.push(...priced.errors.map(e=>({code:e.code,line:e.line,model:e.model})));
    if(!lines.length)errors.push({code:'empty'});
    for(const line of lines){
      const model=catalog.models.find(m=>m.handle===line.model);
      if(!model)continue;
      if(model.selectionNeedsConfirmation)errors.push({code:'modelChoice',line:line.id});
      if(!line.id||ids.has(line.id)){errors.push({code:'duplicateLine'});continue;}ids.add(line.id);
      const rows=line.distribution||[];
      if(!model.variantsVerified||!rows.length||rows.some(r=>!Number.isSafeInteger(r.quantity)||r.quantity<0)||rows.reduce((n,r)=>n+r.quantity,0)!==line.quantity){errors.push({code:'distribution',line:line.id});continue;}
      const activeRows=rows.filter(r=>r.quantity>0);
      activeRows.forEach((row,index)=>{
        const variant=model.variants.find(v=>v.colour===row.colour&&v.size===row.size);
        if(!variant||!safeId(variant.id)||!integer(row.quantity)){errors.push({code:'variant',line:line.id});return;}
        items.push({id:String(variant.id),quantity:row.quantity,properties:{_ws_owner:OWNER,_ws_line:line.id,_ws_row:String(index),_ws_kind:'garment',_ws_logo:line.logo,_ws_model:model.handle,'Bedrukking':({none:'Zonder logo',chest:'Borstlogo',back:'Ruglogo',both:'Borst + rug'})[line.logo]||''}});
      });
      if(line.logo!=='none'){
        const decoration=catalog.checkout?.decorationVariants?.[line.logo];
        const artwork=line.artworkReceipt;
        if(!safeId(decoration))errors.push({code:'decoration',line:line.id});
        // A local filename or a customer-supplied URL is not an upload receipt.
        // Only the authenticated upload integration may provide this reference;
        // the independent checkout validation must verify it again server-side.
        if(!artwork||typeof artwork.reference!=='string'||!artwork.reference||artwork.verified!==true)errors.push({code:'artwork',line:line.id});
        if(safeId(decoration)&&artwork?.reference)items.push({id:String(decoration),quantity:line.quantity,properties:{_ws_owner:OWNER,_ws_line:line.id,_ws_row:'dtf',_ws_kind:'decoration',_ws_logo:line.logo,_ws_model:model.handle,_ws_artwork:artwork.reference,'Kledingmodel':model.name,'Drukproef':'Bestandscontrole vereist'}});
      }
    }
    return {valid:!errors.length&&priced.valid,errors,items,expectedGross:priced.gross,expectedNet:priced.net,currency:catalog.currency};
  }
  function diff(cart,desired){
    if(cart.items.some(i=>i.properties?._ws_owner!==OWNER))return {valid:false,code:'foreignCart',updates:{},additions:[]};
    const pending=new Map();
    for(const item of desired){const id=identity(item),first=pending.get(id);if(first)first.quantity+=item.quantity;else pending.set(id,{...item});}
    const updates={};
    for(const item of cart.items){const id=identity(item),target=pending.get(id);updates[item.key]=target?target.quantity:0;pending.delete(id);}
    return {valid:true,updates,additions:[...pending.values()]};
  }
  function reconcile(cart,planned){
    if(!planned.valid)return {valid:false,code:'selection'};
    if(cart.currency!==planned.currency)return {valid:false,code:'currency'};
    const expected=new Map(),actual=new Map();
    for(const item of planned.items){const k=identity(item);expected.set(k,(expected.get(k)||0)+item.quantity);}
    for(const item of cart.items){
      if(item.properties?._ws_owner!==OWNER)return {valid:false,code:'foreignCart'};
      const k=identity(item);actual.set(k,(actual.get(k)||0)+item.quantity);
    }
    if(expected.size!==actual.size||[...expected].some(([k,q])=>actual.get(k)!==q))return {valid:false,code:'cartChanged'};
    if(!Number.isSafeInteger(cart.total_price)||cart.total_price!==planned.expectedGross)return {valid:false,code:'priceMismatch',expected:planned.expectedGross,actual:cart.total_price};
    return {valid:true,total:cart.total_price};
  }
  async function sync(planned,root,request){
    if(!planned.valid)throw Object.assign(new Error('selection'),{code:'selection'});
    const base=root.replace(/\/?$/,'/');
    const get=()=>request(base+'cart.js');
    const post=(path,body)=>request(base+path,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
    const before=await get(),changes=diff(before,planned.items);
    if(!changes.valid)throw Object.assign(new Error(changes.code),{code:changes.code});
    if(Object.entries(changes.updates).some(([key,q])=>before.items.find(i=>i.key===key)?.quantity!==q))await post('cart/update.js',{updates:changes.updates});
    if(changes.additions.length)await post('cart/add.js',{items:changes.additions});
    const after=await get(),check=reconcile(after,planned);
    if(!check.valid)throw Object.assign(new Error(check.code),check);
    return after;
  }
  return {OWNER,identity,readiness,plan,diff,reconcile,sync};
});
